var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRound3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.77,379.08c-50.32,0-70.72-37.74-70.72-55.76,0-10.54,5.44-16.66,12.58-16.66,8.84,0,13.26,5.1,16.66,15.64,5.78,17.34,18,30.94,40.8,30.94,26.86,0,45.9-20.06,45.9-44.88,0-36-19.72-45.22-42.16-45.22-11.9,0-18.36-5.1-18.36-12.92,0-6.8,4.42-10.54,15.64-12.92,24.14-5.44,34-17,34-39.1,0-23.12-13.6-39.44-34.34-39.44-23.8,0-32.64,17-34.34,35.36-1,13.6-9.18,13.94-14.28,13.94-8.5,0-13.6-6.12-13.6-13.94,0-32.3,23.46-61.2,63.58-61.2,38.76,0,62.9,28.56,62.9,62.56,0,20.06-9.52,39.78-28.56,51.34C310.67,255,325,278.1,325,305.64,325,351.54,291,379.08,247.77,379.08ZM256,480C132.49,480,32,379.51,32,256S132.49,32,256,32,480,132.49,480,256,379.51,480,256,480Zm0-416C150.13,64,64,150.13,64,256s86.13,192,192,192,192-86.13,192-192S361.87,64,256,64Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRound3);
export default __webpack_public_path__ + "static/media/icon-round-3.377fe5ae.svg";
export { ForwardRef as ReactComponent };